import { FC } from 'react'
import { PreventScrollOwnProps, PreventScroll } from 'components/features/pfm/PreventScroll/PreventScroll'

/*
* TODO: this is a bad fix. Ideally `PreventScroll` (which is actually a scroll marker) should be joined with `Scrollable`.
*
* `DropdownItems` does not render any content if no options. Therefore the content is dynamic and may be missed by `PreventScrollContextProvider`.
* So to notify it we need to explicitly use `PreventScroll` here.
*/

type PreventScrollOptionalProps =
  & PreventScrollOwnProps
  & {
    isWrapped?: boolean
  }

export const PreventScrollOptional: FC<PreventScrollOptionalProps> = (props) => {
  const { isWrapped, children, ...restProps } = props

  if (!isWrapped) {
    return (
      <>
        { children }
      </>
    )
  }

  return (
    <PreventScroll { ...restProps }>
      { children }
    </PreventScroll>
  )

}
